import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var giftCard24Icon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.7 3C23 3 24 4 24 5.2v13.6c0 1.2-1.1 2.2-2.3 2.2H2.2C1 21 0 20 0 18.7V5.2C0 4 1 3 2.2 3ZM1.4 18.8c.1.5.4.8.8.8h9V14H1.4ZM22.5 14h-9.7v5.6h8.9c.462 0 .753-.34.795-.708l.005-.092V14Zm-.8-9.5v-.1h-8.9v8.1h9.7V5.3a.785.785 0 0 0-.708-.795L21.7 4.5Zm-10.5-.1h-9c-.5.1-.8.4-.8.8v7.3h9.8V4.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.344 13.431.056.069c.3.3.3.8 0 1.1l-3 3-.5.5-.3-.4c-.4-.4-.4-1 0-1.4l2.8-2.8c.275-.275.718-.298.944-.069Zm1.256.069c.3-.3.8-.3 1.1 0l2.8 2.8c.4.4.4 1 0 1.4l-.4.4-.5-.5-3-3c-.3-.3-.3-.8 0-1.1Zm5.9-6.6a3.016 3.016 0 0 1 .133 4.159l-.133.141c-1 1-4.4 1.6-5.1 1.7l-.2-.1c-.2 0-.4-.1-.5-.2-.2-.2-.3-.4-.2-.6.1-.7.7-4.1 1.7-5.1 1.2-1.2 3.1-1.2 4.3 0Zm-8.6-.1c1 1 1.6 4.5 1.7 5.1 0 .2 0 .5-.2.6-.2.3-.4.3-.6.3h-.1c-.7-.1-4.1-.7-5.1-1.7-1.2-1.2-1.2-3.1 0-4.3 1.2-1.2 3.1-1.2 4.3 0Zm6.4.6c-.4 0-.8.2-1.1.4-.6 1-.9 2.1-1.1 3.3 1.1-.2 2.2-.6 3.2-1.1.6-.6.6-1.5 0-2.1-.2-.3-.6-.5-1-.5Zm-8.6 0c-.8 0-1.5.7-1.5 1.6 0 .4.2.8.4 1 1 .6 2.1.9 3.2 1.1-.1-1.1-.5-2.2-1-3.2-.3-.3-.7-.5-1.1-.5Z"
})));

export { giftCard24Icon as default };
//# sourceMappingURL=giftCard24Icon.js.map
